export default "__VITE_ASSET__DpZXL2x2__"